module.exports = __webpack_public_path__ + "img/符合機械雲標準Runtime APP型式.f7eced85.png";